module.exports = __webpack_public_path__ + "img/member_reservation_logo.4b38206c.png";